// ------------------------------------------------------------------------------
//  This code is generated by a tool.
//  Manual Changes to this file will be lost.
//  Based on C# type: Euronics.Model.Enums.Site
// ------------------------------------------------------------------------------
export enum Site {
  EuronicsEE = 'EuronicsEE', 
  EuronicsLV = 'EuronicsLV', 
  NovastarLT = 'NovastarLT', 
  ElesenLT = 'ElesenLT'
}
